import { Team } from '../../shared/models/departure.model';

export function sortAscendingNumber(firstTeam: Team, secondTeam: Team): number {
  const firstTeamNumber: number = Number(firstTeam.name.replace(/\D+/g, ''));
  const secondTeamNumber: number = Number(secondTeam.name.replace(/\D+/g, ''));

  if (firstTeamNumber > secondTeamNumber) {
    return 1;
  }
  if (firstTeamNumber < secondTeamNumber) {
    return -1;
  }
  return 0;
}

export function sortAscendingCompanyName(
  firstCompany:
    | {
        company_name: string;
        summaries: {
          state: 'NoShifts' | 'NoRotations' | 'ClosedSince' | '';
          closed_since: number | null;
          team_id: string;
          team_name: string;
          summaries:
            | {
                actual_members: number;
                created_at: number;
                driver: string;
                planned_members: number;
                shift_id: string;
                team_id: string;
                shift_initiator: 'ShiftRotation' | 'ShiftOpening' | 'ShiftClosing';
                team_request_time: number;
                request_resolved_time: number;
                intern?: string;
                guard?: string;
              }[]
            | null;
        }[];
      }
    | { name: string; id: string },
  secondCompany:
    | {
        company_name: string;
        summaries: {
          state: 'NoShifts' | 'NoRotations' | 'ClosedSince' | '';
          closed_since: number | null;
          team_id: string;
          team_name: string;
          summaries:
            | {
                actual_members: number;
                created_at: number;
                driver: string;
                planned_members: number;
                shift_id: string;
                team_id: string;
                shift_initiator: 'ShiftRotation' | 'ShiftOpening' | 'ShiftClosing';
                team_request_time: number;
                request_resolved_time: number;
                intern?: string;
                guard?: string;
              }[]
            | null;
        }[];
      }
    | { name: string; id: string },
): number {
  if (
    ('company_name' in firstCompany &&
      'company_name' in secondCompany &&
      firstCompany.company_name < secondCompany.company_name) ||
    ('name' in firstCompany && 'name' in secondCompany && firstCompany.name < secondCompany.name)
  ) {
    return -1;
  }
  if (
    ('company_name' in firstCompany &&
      'company_name' in secondCompany &&
      firstCompany.company_name > secondCompany.company_name) ||
    ('name' in firstCompany && 'name' in secondCompany && firstCompany.name > secondCompany.name)
  ) {
    return 1;
  }
  return 0;
}

export function sortAscendingTeamName(
  firstTeam: {
    state: 'NoShifts' | 'NoRotations' | 'ClosedSince' | '';
    closed_since: number | null;
    team_id: string;
    team_name: string;
    summaries:
      | {
          actual_members: number;
          created_at: number;
          driver: string;
          planned_members: number;
          shift_id: string;
          team_id: string;
          shift_initiator: 'ShiftRotation' | 'ShiftOpening' | 'ShiftClosing';
          team_request_time: number;
          request_resolved_time: number;
          intern?: string;
          guard?: string;
        }[]
      | null;
  },
  secondTeam: {
    state: 'NoShifts' | 'NoRotations' | 'ClosedSince' | '';
    closed_since: number | null;
    team_id: string;
    team_name: string;
    summaries:
      | {
          actual_members: number;
          created_at: number;
          driver: string;
          planned_members: number;
          shift_id: string;
          team_id: string;
          shift_initiator: 'ShiftRotation' | 'ShiftOpening' | 'ShiftClosing';
          team_request_time: number;
          request_resolved_time: number;
          intern?: string;
          guard?: string;
        }[]
      | null;
  },
): number {
  const firstTeamNumber: number = Number(firstTeam.team_name.replace(/\D+/g, ''));
  const secondTeamNumber: number = Number(secondTeam.team_name.replace(/\D+/g, ''));

  if (firstTeamNumber > secondTeamNumber) {
    return 1;
  }
  if (firstTeamNumber < secondTeamNumber) {
    return -1;
  }
  return 0;
}
